
/* eslint-env browser */
/* global viewer */

window.WebFontConfig = {

	active: function() {
		"use strict";
		viewer.onWebFontsLoaded();
	},

	inactive: function() {
		"use strict";
		viewer.onWebFontsLoadFailed();
	},

	custom: {
		families: ["SkanskaSansProRegular", "SkanskaSansProBold"],
		urls: ["css/app.css"]
	}
};
